import { PropsWithChildren, ReactNode, useState } from 'react';

import IconChevron from '@/icons/Chevron.svg';
import IconError from '@/icons/Error.svg';
import { createBEMClasses } from '@/utils/classname';

import Button from '../Button';

import './FoldableSection.css';

const { block, element } = createBEMClasses('foldable-section');

const FoldableSection = ({
  label,
  labelOutsideButton,
  withHeaderRightSeparator,
  size = 'medium',
  startClosed,
  isInvalid,
  children,
}: PropsWithChildren<{
  label: ReactNode;
  labelOutsideButton?: ReactNode | ((isOpen: boolean) => ReactNode);
  withHeaderRightSeparator?: boolean;
  size?: 'small' | 'medium';
  isInvalid?: boolean;
  startClosed?: boolean;
}>) => {
  const [isOpen, setIsOpen] = useState(!startClosed);

  const resolvedLabelOutsideButton =
    typeof labelOutsideButton === 'function' ? labelOutsideButton(isOpen) : labelOutsideButton;

  return (
    <section className={block({ isOpen, size, withHeaderRightSeparator })}>
      <header className={element('header')}>
        <Button
          variant="style-less"
          onPress={() => setIsOpen((prev) => !prev)}
          className={element('trigger')}
        >
          <IconChevron right className={element('icon')} />
          {isInvalid && <IconError className="text-danger" fontSize="1.25rem" />}
          {label}
        </Button>
        {resolvedLabelOutsideButton && (
          <div className={element('header-right')}>{resolvedLabelOutsideButton}</div>
        )}
      </header>
      <main inert={isOpen ? false : true}>
        <div>{children}</div>
      </main>
    </section>
  );
};

export default FoldableSection;
